import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormInput from '../../../library/form/components/FormInput';
import FormHHMMInput from '../../../library/form/components/FormHHMMInput';
import * as fn from "../../../helper/uiFunctions";

const ProjectTimesheetRow = (props) => {
    const { formObject, viewData, index, rowKey } = props;

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return ( 
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    {index}
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "tsDate" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "startTime" }} />
                    </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "endTime" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "workMins" }} />
                </li>
               <li className="uiColumnCenter uiColumn70">
                    <FormHHMMInput formObject={formObject} rowKey={rowKey} className="uiTimeInput" 
                            action={{ InputType: "input", paramName: "manualMins", actionParam: {} }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormCheckbox formObject={formObject} rowKey={rowKey} action={{
                        InputType: "onOff", paramName: "isNoWork", actionId: "refresh", actionParam: {}
                    }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "reason" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" action={{InputType: "input", paramName: "comment"}} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "save", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "cancel", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    {index}
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "tsDate" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "startTime" }} />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "endTime" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "workMins" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "manualMins" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isNoWork" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "reason" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit", actionParam: {}, containerKey: "row" }}
                        className="s" ></FormButton>
                </li>
            </ul>
        )
    }
}

export default ProjectTimesheetRow
